module.exports = __webpack_public_path__ + "img/ta-3.d3974ce4.jpg";